import { gql } from "@apollo/client";

export const CREATE_STOCK_UNIT = gql`
  mutation CreateStockUnitMutation($input: CreateStockUnitInput!) {
    createStockUnit(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_STOCK_UNIT = gql`
  mutation UpdateStockUnitMutation($id: Int!, $input: UpdateStockUnitInput!) {
    updateStockUnit(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const EXIT_STOCK_UNIT = gql`
  mutation ExitStockUnitMutation(
    $id: Int!
    $exitReason: StockExitReason!
    $issueComment: String
    $orderId: Int
  ) {
    exitStockUnit(
      id: $id
      exitReason: $exitReason
      issueComment: $issueComment
      orderId: $orderId
    ) {
      ok
      error
    }
  }
`;

export const STOCK_UNIT = gql`
  query StockUnitQuery($id: Int!) {
    stockUnit(id: $id) {
      ok
      error
      result {
        id
        batchNumber
        quantity
        enteredAt
        exitedAt
        exitReason
        issueComment
        qrCode {
          id
          code
        }
        product {
          id
          name
        }
        warehouse {
          id
          name
        }
        order {
          id
          number
        }
      }
    }
  }
`;

export const STOCK_UNIT_BY_QR_CODE = gql`
  query StockUnitByQrCodeQuery($qrCode: String!) {
    stockUnitByQrCode(qrCode: $qrCode) {
      ok
      error
      result {
        id
        batchNumber
        quantity
        enteredAt
        exitedAt
        exitReason
        qrCode {
          id
          code
        }
        product {
          id
          name
        }
        warehouse {
          id
          name
        }
      }
    }
  }
`;

export const STOCK_UNITS = gql`
  query StockUnitsQuery($where: StockUnitsFiltersInput!) {
    stockUnits(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        batchNumber
        quantity
        enteredAt
        exitedAt
        exitReason
        product {
          id
          name
        }
        warehouse {
          id
          name
        }
      }
    }
  }
`;
